define('shared/initializer/form/newHouseAdapters/util/getTrackingPayload',[
    '$',
    'shared/lib/RSVP',
    'shared/util/dispatchers/DataDispatcher',
    'shared/util/queryPersistence',
    'shared/util/state',
    './ValueCollectorForDataDispatcher',
    'shared/util/tracking/clientIds'
],
function ( 
    $,
    RSVP,
    DataDispatcher,
    queryPersistence,
    state,
    ValueCollectorForDataDispatcher,
    clientIds
) {
    'use strict';


    return function() {
        var payload = {};
        var collector = new ValueCollectorForDataDispatcher(payload);
        
        return RSVP.resolve()
            .then(function(){
                return new DataDispatcher($(document.documentElement))
                    .dispatch({
                        items:{
                            'hasOffersTransactionId':
                            {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.hoTransactionId, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'google.clickId':
                            {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.gclid, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'marin.clickId':
                            {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.ruboid, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'utm.source': {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_source, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'utm.medium': {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_medium, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'utm.campaign': {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_campaign, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'utm.term': {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_term, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'utm.content': {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_content, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'utm.adGroup': {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.adgroup, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'ga.clientId': {
                                sources: [{type: 'clientId', key: clientIds.CONSTANT.GAClientId, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'adobe.visitorId': {
                                sources: [{type: 'clientId', key: clientIds.CONSTANT.AdobeVisitorId, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            }
                        },
                        timeout: 1000 * 60 * 60
                    });
            })
            .then(function(){
                return state.retrieve('page.name');
            })
            .then(function(pageName){
                payload.sourcePage = {
                    name: pageName
                };
                // vahid says it is always AEM for now
                payload.sourceSystem = {
                    name: 'AEM'
                };
                return payload;
            });
    };
});
